// @flow
import React, { useEffect, useState } from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import RowLayout from 'app/common/layouts/RowLayout';
import Loading from 'app/common/components/Loader';


/**
 * Загружает следующую порцию заказов, когда компонент становится видимым
 */

type Props = {
  loading?: boolean,
  onVisible?: () => Promise<boolean> | boolean,
  disable?: boolean,
};

const OrdersLoader = ({ loading, onVisible, disable }: Props) => {
  const [visibility, setVisibility] = useState(false);
  const [mounted, setMounte] = useState(false);

  useEffect(() => {
    if (!mounted) {
      setMounte(true);
      return;
    }
    if (mounted && visibility && onVisible && !disable) {
      onVisible();
    }
  }, [visibility]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <VisibilitySensor onChange={setVisibility} partialVisibility delayedCall>
      {loading
        ? <RowLayout>
          <Loading />
        </RowLayout>
        : <div>&nbsp;</div>}
    </VisibilitySensor>
  );
};

export default OrdersLoader;
